export default __webpack_public_path__ + "static/media/gray_bottle.6d88a9e1.svg";